/**
 * Labstep
 *
 * @module state/reducers/helpers/entities/entityRelation
 * @desc Helpers for entityRelation reducer
 */

import type { Action } from 'labstep-web/models/action.model';
import { uniq } from 'lodash';

/**
 * @description Updates entity_relation_preview on metadata when new entity relations are created
 */
export const metadataEntityRelationPreviewUpdate = (
  state: any,
  action: Action,
): any => {
  const resourceGuids = Object.values(
    action.payload.entities.resource,
  ).map((r: any) => r.guid);

  const entityRelations = Object.values(
    action.payload.entities.entity_relation,
  );

  const inboundState: any = {};

  entityRelations.forEach((entityRelation: any) => {
    if (!entityRelation.field_definition) {
      return;
    }
    const metadatas = Object.values(state).filter(
      (metadata: any) =>
        metadata.field_definition &&
        metadata.field_definition ===
          entityRelation.field_definition &&
        metadata.permission_entity_info &&
        resourceGuids.includes(metadata.permission_entity_info.guid),
    );

    metadatas.forEach((metadata: any) => {
      const metadataFromState = state[metadata.id];
      const currentPreview = metadata.entity_relation_preview || [];
      const updatedPreview = uniq([
        ...currentPreview,
        ...((inboundState[metadata.id] &&
          inboundState[metadata.id].entity_relation_preview) ||
          []),
        entityRelation.id,
      ]);

      inboundState[metadata.id] = {
        ...(inboundState[metadata.id] && {
          ...inboundState[metadata.id],
        }),
        ...metadataFromState,
        ...metadata,
        entity_relation_preview: updatedPreview,
      };
    });
  });
  return {
    ...state,
    ...inboundState,
  };
};

/**
 * @description Removes deleted entity relations from entity_relation_preview on metadata
 */
export const metadataEntityRelationPreviewRemove = (
  state: any,
  action: Action,
): any => {
  const resourceGuids = Object.values(
    action.payload.entities.resource,
  ).map((r: any) => r.guid);

  const entityRelations = Object.values(
    action.payload.entities.entity_relation,
  );

  const inboundState: any = {};

  entityRelations.forEach((entityRelation: any) => {
    if (
      !entityRelation.field_definition ||
      !entityRelation.deleted_at
    ) {
      return;
    }
    const metadatas = Object.values(state).filter(
      (metadata: any) =>
        metadata.field_definition &&
        metadata.field_definition ===
          entityRelation.field_definition &&
        metadata.permission_entity_info &&
        resourceGuids.includes(metadata.permission_entity_info.guid),
    );

    metadatas.forEach((metadata: any) => {
      const metadataFromState = state[metadata.id];
      const currentPreview = inboundState[metadata.id]
        ? inboundState[metadata.id].entity_relation_preview
        : metadata.entity_relation_preview || [];

      const updatedPreview = currentPreview.filter(
        (relation: any) => relation !== entityRelation.id,
      );

      inboundState[metadata.id] = {
        ...(inboundState[metadata.id] && {
          ...inboundState[metadata.id],
        }),
        ...metadataFromState,
        ...metadata,
        entity_relation_preview: updatedPreview,
      };
    });
  });

  return {
    ...state,
    ...inboundState,
  };
};
